import React from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { SubmitButton } from '../../../../shared/components';
import { useResetPasswordFormContext } from './helpers/useResetPasswordFormContext';
import { useResetPasswordHasRequiredFields } from './helpers/useResetPasswordHasRequiredFields';
import { AuthFormActions as Actions } from '../../../shared/form-layout/AuthFormActions';

export const ResetPasswordFormActions = () => {
	const { t } = useTranslation();
	const { formState } = useResetPasswordFormContext();

	const hasRequiredFields = useResetPasswordHasRequiredFields();
	const disabled = !hasRequiredFields || formState.isSubmitting;

	return (
		<Actions>
			<SubmitButton disabled={disabled}>
				{t('user_reset_password_submit_button')}
			</SubmitButton>
		</Actions>
	);
};
